<div class="blog-search-holder">
  <div class="back-holder" (click)="closeSearch()">
    <img src="assets/general/back-blue.svg" />
  </div>
  <div class="blog-search-div">
    <div class="blog-search-input-holder">
      <div class="blog-search-icon">
        <img src="assets/blog/search.svg" />
      </div>
      <input
        class="blog-search-input"
        [(ngModel)]="searchText"
        placeholder="جستجو کنید"
        type="text"
        (ngModelChange)="checkSearchVal()"
        autocomplete="off"
      />
      <div
        class="blog-search-remove"
        *ngIf="searchText"
        (click)="clearSearchText()"
      >
        <img src="assets/blog/close.svg" />
      </div>
    </div>
    <div class="item-header" (click)="changePage(0)">همه</div>
    <div class="item-header" (click)="changePage(1)">هشتگ</div>
    <div class="item-header" (click)="changePage(2)">نام کاربری</div>
    <div
      class="item-indicator"
      [ngStyle]="{ right: page === 0 ? '0' : page === 1 ? '33%' : '67%' }"
    ></div>
  </div>
  <p
    *ngIf="
      searchedTags.length === 0 &&
      searchedUsers.length === 0 &&
      searchText &&
      page === 0
    "
    class="center-text"
  >
    تگ یا نام کاربری مورد نظر یافت نشد
  </p>
  <p *ngIf="!searchText && page === 0" class="center-text">
    تگ یا نام کاربری مورد نظر خود را جستجو کنید
  </p>
  <p
    *ngIf="searchedTags.length === 0 && searchText && page === 1"
    class="center-text"
  >
    تگ مورد نظر یافت نشد
  </p>
  <p *ngIf="!searchText && page === 1" class="center-text">
    تگ مورد نظر خود را جستجو کنید
  </p>
  <p
    *ngIf="searchedUsers.length === 0 && searchText && page === 2"
    class="center-text"
  >
    نام کاربری مورد نظر یافت نشد
  </p>
  <p *ngIf="!searchText && page === 2" class="center-text">
    نام کاربری مورد نظر خود را جستجو کنید
  </p>
  <div
    class="tableView"
    *ngIf="searchedTags.length !== 0 || searchedUsers.length !== 0"
  >
    <table class="table table-striped">
      <tbody>
        <tr
          *ngFor="let tag of searchedTags; let i = index"
          (click)="openBlogWithTag(tag)"
        >
          <td>
            <div class="table-row-img">
              <p>#</p>
            </div>
            <div class="table-row-title">
              {{ tag.title }}
            </div>
            <div class="table-row-post-count">{{ tag.postCount }} پست</div>
          </td>
        </tr>
        <tr
          *ngFor="let user of searchedUsers; let i = index"
          (click)="profile(user.userName)"
        >
          <td>
            <img
              class="user-avatar"
              *ngIf="user.avatarPath !== ''"
              src="{{ user.avatarPath }}"
              onerror="this.onerror=null; this.src='assets/blog/avatar.svg'"
            />
            <img
              class="user-avatar"
              *ngIf="user.avatarPath === ''"
              src="assets/blog/avatar.svg"
            />
            <div class="user-username">{{ user.userName }}</div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

</div>
